(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.RambowtechCore = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function nextQuantity(current, delta, minimum) {
    var value = parseInt(current, 10);
    if (isNaN(value)) value = minimum;
    return Math.max(minimum, value + delta);
  }

  function cartPageUrl(settings) {
    var routes = (settings && settings.routes) || {};
    var url = routes.cartPage || '/cart';
    return /\.js(?:[?#]|$)/.test(url) ? '/cart' : url;
  }

  function cartState(cart, thresholdCents) {
    cart = cart || {};
    var total = Number(cart.total_price) || 0;
    var threshold = Math.max(0, Number(thresholdCents) || 0);
    var remaining = threshold > 0 ? Math.max(0, threshold - total) : 0;
    var progress = threshold > 0 ? Math.min(100, Math.round((total * 100) / threshold)) : 100;
    var lines = {};
    (cart.items || []).forEach(function (item) {
      lines[item.key] = {
        quantity: Number(item.quantity) || 0,
        finalLinePrice: Number(item.final_line_price) || 0
      };
    });
    return {
      itemCount: Number(cart.item_count) || 0,
      totalPrice: total,
      // the items before order discounts, and each order discount (a code Shopify took off in the cart)
      itemsSubtotal: cart.items_subtotal_price == null ? total : Number(cart.items_subtotal_price) || 0,
      discounts: (cart.cart_level_discount_applications || []).map(function (d) {
        return { title: String(d.title || ''), amount: Number(d.total_allocated_amount) || 0 };
      }),
      threshold: threshold,
      remaining: remaining,
      progress: progress,
      freeShipping: threshold > 0 && remaining === 0,
      lines: lines
    };
  }

  return { nextQuantity: nextQuantity, cartPageUrl: cartPageUrl, cartState: cartState };
});
